import React, { useRef, useEffect, useState } from 'react'
import { Box, Tooltip, TooltipProps } from '@mui/material'

interface Props extends Partial<Omit<TooltipProps, 'children'>> {}

const OverflowToolTip: ReactFC<Props> = ({
  children,
  sx,
  title,
  ...tooltipProps
}) => {
  // Create Ref
  const textElementRef = useRef<HTMLDivElement>()

  const compareSize = () => {
    if (!textElementRef.current) return
    const compare =
      textElementRef.current.scrollWidth > textElementRef.current.clientWidth
    setHover(compare)
  }

  // compare once and add resize listener on "componentDidMount"
  useEffect(() => {
    compareSize()
    window.addEventListener('resize', compareSize)
    return () => {
      window.removeEventListener('resize', compareSize)
    }
  }, [])

  // Define state and function to update the value
  const [hoverStatus, setHover] = useState(false)

  return (
    <Tooltip
      title={title ?? children ?? ''}
      disableHoverListener={!hoverStatus}
      sx={{
        ...sx
      }}
      {...tooltipProps}
    >
      <Box
        ref={textElementRef}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {children}
      </Box>
    </Tooltip>
  )
}

export default OverflowToolTip
